export var Sizes = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};